import React, { useContext } from "react";
import {
  SpreadsheetContext,
  CellError,
} from "@gistapps/composite-spreadsheet";
import type {
  DataViewerProps,
} from "@gistapps/composite-spreadsheet";

const ImageCellViewer = ({ cell, row, column }: DataViewerProps) => {

  const {
    errors,
    translations,
  } = useContext(SpreadsheetContext);

  const hasError = !!errors?.[row]?.[column];
  const errorMessage = translations?.error_invalid_value || "Please enter a valid value";
  const value = cell?.value as string | undefined;

  return (typeof value === "string" && value.startsWith("http")) ?
    <div className={`Spreadsheet__data-viewer rss__data-viewer${hasError ? " rss__data-viewer--error" : ""}`}>
      <div className="gc__cell-image-wrapper">
        <img
          src={value}
          className="gc__table-image"
          alt=""
        />
      </div>
      {hasError ? <CellError message={errorMessage} /> : null}
    </div>
  : hasError ?
    <div className="Spreadsheet__data-viewer rss__data-viewer rss__data-viewer--error">
      <CellError message={errorMessage} />
    </div>
  : null;

};

export default ImageCellViewer;
